import { ProgramContentType } from "data/BlockComponent";
import { useRecoilValue } from "recoil";
import AudioButtonWeb from "./audio/AudioButtonWeb";
import { AudioType, ContentType } from "data/CellComponent";
import useIsInappWebview from "hooks/useIsInappWebview";
import useDetectIOS from "hooks/useDetectIOS";
import useGetLocale from "hooks/useGetLocale";
import { userAtom } from "recoil/userAtom";
import useGetTaskTitleFromTaskKey from "hooks/useGetTaskTitleFromTaskKey";
import useGetDeviceInfo from "hooks/useGetDeviceInfo";
import { compareVersions } from "logic/logics_common";
import { createAudioInstanceKey } from "logic/logics";
import { useState } from "react";
import AudioButtonWebviewLegacy from "./audio/legacy/AudioButtonWebviewLegacy";
import AudioButtonWebLegacy from './audio/legacy/AudioButtonWebLegacy'

export default function AudioButtonCell({
  content,
  blockIndex,
  lineIndex,
  cellIndex,
  taskKey,
  meditationRecordKey,
  setData,
  readonly,
}: {
  content: ContentType;
  blockIndex: number;
  lineIndex: number;
  cellIndex: number;
  taskKey: string;
  meditationRecordKey?: string;
  setData: React.Dispatch<
    React.SetStateAction<ProgramContentType[] | undefined>
  >;
  readonly: boolean;
}) {
  const isInappWebview = useIsInappWebview();
  const { isIOS } = useDetectIOS();

  const user = useRecoilValue(userAtom);
  const isCoach = (user?.accessToken && user?.role !== "patient") || false;

  const locale = useGetLocale();

  const taskTitle = useGetTaskTitleFromTaskKey(taskKey, true);

  const getMeditationInfo = (audioUrl: string) => {
    const map: Record<string, { title: string; artwork: string }> = {
      stream_of_thoughts: { title: "생각의 강", artwork: "stream.png" },
      sky_of_thoughts: { title: "생각의 하늘", artwork: "sky.png" },
      factory_of_thoughts: { title: "생각의 공장", artwork: "factory.png" },

      body_scan: { title: "바디스캔", artwork: "body_scan.png" },
      observing_body_feelings: { title: "바디스캔", artwork: "body_scan.png" },
      value_wrapup: { title: "가치 확언", artwork: "value.png" },
      distancing_thoughtmap: {
        title: "생각 그물",
        artwork: "thought_map.png",
      },
      observing_thoughts: { title: "생각 그물", artwork: "thought_map.png" },
      grounding: { title: "심호흡 그라운딩", artwork: "grounding.png" },
      relaxation: { title: "근육이완법", artwork: "relaxation.png" },
      breath: { title: "호흡 명상", artwork: "breath.png" },
      willingness: { title: "기꺼이 경험하기", artwork: "willingness.png" },
    };

    const key = Object.keys(map).find((k) => audioUrl.startsWith(k));
    return key ? map[key] : undefined;
  };

  const audioInstanceKey = createAudioInstanceKey(
    taskKey,
    meditationRecordKey,
    (content as AudioType).audioUrl
  );

  const meditationInfo = getMeditationInfo((content as AudioType).audioUrl);

  const mrk = (content as AudioType).mrk;
  if (mrk !== undefined && mrk !== meditationRecordKey) {
    // TODO 왜 달라지는건지 원인 찾아야함. 우선 방어로직 넣어놓음
    // alert(`${mrk} -> ${meditationRecordKey}`);
    return <></>;
  }

  return isInappWebview && !isIOS ? (
    <AudioButtonWebviewLegacy
      audioInstanceKey={audioInstanceKey}
      key={meditationRecordKey !== undefined ? meditationRecordKey : taskKey}
      audioUrl={`https://media.distancing.im/audio/${
        (content as AudioType).audioUrl
      }_${locale}.mp3`}
      initialTime={Math.floor((content as AudioType).currentTime || 0)}
      setData={setData}
      blockIndex={blockIndex}
      lineIndex={lineIndex}
      cellIndex={cellIndex}
      isCoach={isCoach}
      {...(meditationInfo && {
        title: meditationInfo.title,
        artist: taskTitle,
        artwork: `https://media.distancing.im/artwork/meditation/${meditationInfo.artwork}`,
      })}
      {...((content as AudioType).extraAudioUrl && {
        extraAudioUrl: `https://media.distancing.im/audio/${
          (content as AudioType).extraAudioUrl
        }_${locale}.mp3`,
      })}
      extraLoopNumber={(content as AudioType).extraLoopNumber}
      readonly={readonly}
    />
  ) : (
    <AudioButtonWebLegacy
      audioInstanceKey={audioInstanceKey}
      key={audioInstanceKey}
      audioUrl={`https://media.distancing.im/audio/${
        (content as AudioType).audioUrl
      }_${locale}.mp3`}
      initialTime={Math.floor((content as AudioType).currentTime || 0)}
      setData={setData}
      blockIndex={blockIndex}
      lineIndex={lineIndex}
      cellIndex={cellIndex}
      isCoach={isCoach}
      {...((content as AudioType).extraAudioUrl && {
        extraAudioUrl: `https://media.distancing.im/audio/${
          (content as AudioType).extraAudioUrl
        }_${locale}.mp3`,
      })}
      extraLoopNumber={(content as AudioType).extraLoopNumber}
      readonly={readonly}
    />
  );
}
